import { Outlet } from "react-router-dom";
import AbTestsProvider from "src/context/AbTestsProvider";
import AnswersProvider from "src/context/AnswersProvider";
import ProductProvider from "src/context/ProductProvider";
import VisitProvider from "src/context/VisitProvider";

const ProductVisitLayout = () => {
  return (
    // This is a very basic version of the layout with time, we can update it and add more if necessary.
    <ProductProvider>
      <AbTestsProvider>
        <VisitProvider>
          <AnswersProvider>
            <Outlet />
          </AnswersProvider>
        </VisitProvider>
      </AbTestsProvider>
    </ProductProvider>
  );
};

export default ProductVisitLayout;
